import { watchEffect as f } from "vue";
import { getOwnerDocument as u } from "./index343.js";
function m({ container: e, accept: r, walk: o, enabled: t }) {
  f(() => {
    let a = e.value;
    if (!a || t !== void 0 && !t.value) return;
    let c = u(e);
    if (!c) return;
    let l = Object.assign((i) => r(i), { acceptNode: r }), n = c.createTreeWalker(a, NodeFilter.SHOW_ELEMENT, l, !1);
    for (; n.nextNode(); ) o(n.currentNode);
  });
}
export {
  m as useTreeWalker
};
